import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ReleasesComponent } from "./pages/releases.component";

const routes: Routes = [
	{
		path: "",
		component: ReleasesComponent,
		children: [],
	},
];
@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ReleasesRoutingModule {}
